import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, OocyteQualityAssessmentByCodeController, OocyteQualityAssessmentByCodeRequest, CycleOocyteQualityBetweenDateController, CycleOocyteQualityBetweenDateRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, OocyteMaturityByCycleController, OocyteMaturityByCycleRequest, OocyteMorphologyByCycleController, OocyteMorphologyByCycleRequest, CounsellingActivitiesByTimeController, SaveCounsellingActivityRequest, CounsellingActivitiesByTimeRequest, CounsellingPlanController, CounsellingPlanRequest, MaterialConsumptionEntries2Controller, MaterialConsumptionEntriesRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { OocyteStoreItem } from '../../../testnurse/ivf/ivfworkbench/ivfoqaedit.component';
import { IsSessionExistsRequest } from '../../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Subscription } from 'rxjs';




@Component({
  selector: 'consumptionPV',
  templateUrl: './consumptionPV.component.html',
  styleUrls: ['./consumptionPV.component.scss']
})

export class ConsumptionPVComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  public OQACode: any;
  public Owner: string;
  public ActorCode: number = 0;
  public diff: number = 0;
  public Add: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsToday: boolean = false;
  public IsDuration: boolean = true;
    public IsExpand: boolean = true;
    public SelectedDateNew: Date;
  //public isRequesting: boolean = false;
  public ShowMonitoring: boolean = false;
  public ShowTracking: boolean = true;
  public Showarrow: boolean = false;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public SelectedDay: any;
  public SelectedMonth: any;
  public SelectedYear: any;

  //public ApiResData: ApiResponseModel;
  SelectedToDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  SelectedFromDate2: Date;
  SelectedFromDate3: NgbDateStruct;

  dateI: NgbDateStruct;
  TodayDate = new Date();
  Datediffer = new Date();


  sub: Subscription;
  CurrentMaterialConsumptionEntries2Controller: MaterialConsumptionEntries2Controller[];
  CurrentMaterialConsumptionEntriesRequest: MaterialConsumptionEntriesRequest;
  LoadPatients() {
    this.CurrentMaterialConsumptionEntriesRequest = new MaterialConsumptionEntriesRequest();

    // this.CurrentIahOrdersRequest.BranchCode = AppData.Instance().SelectedBranchCode;


    this.CurrentMaterialConsumptionEntriesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentMaterialConsumptionEntries2Controller;
    this.GetMaterialConsumptionEntries2();
  }

  GetMaterialConsumptionEntries2() {
    this.StartRefreshing();
    this.CurrentMaterialConsumptionEntriesRequest.ConditionalOperator = 10;
    this.CurrentMaterialConsumptionEntriesRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentMaterialConsumptionEntriesRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentMaterialConsumptionEntriesRequest.ToDate = new Date();

    this.actorservice.GetMaterialConsumptionEntries2(this.CurrentMaterialConsumptionEntriesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentMaterialConsumptionEntries2Controller = this.ApiResData.Result;
          //this.pdata = this.CurrentMaterialConsumptionEntries2Controller;
          this.stopRefreshing();
          this.LoadCounselling();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentCounsellingPlanController: CounsellingPlanController[];
  CurrentCounsellingPlanRequest: CounsellingPlanRequest;

  LoadCounselling() {

    this.CurrentCounsellingPlanRequest = new CounsellingPlanRequest();
    this.CurrentCounsellingPlanRequest.ActorCode = this.ActorCode.toString();
    this.CurrentCounsellingPlanRequest.BranchCode = AppData.Instance().SelectedBranchCode;

    //alert(this.ActorCode);
    this.CurrentCounsellingPlanRequest.ConditionalOperator = 20;
    this.CurrentCounsellingPlanRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetCounsellingPlanController();
  }
  //SelectedPatientEmergencyDetails: VitalLatestFormByFormattedCodeController;
  GetCounsellingPlanController() {
    this.StartRefreshing();
    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetCounsellingPlanController(this.CurrentCounsellingPlanRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

            this.CurrentCounsellingPlanController = this.ApiResData.Result;
            
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

          //this.SelectedPatientEmergencyDetails = this.CurrentVitalLatestFormByFormattedCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();
          this.printService.onDataReady();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
    //alert("in scans comp");
    //this.Date = new Date();

    //this.SelectedFromDate = this.route.snapshot.paramMap.get('SelectedFromDate');
    this.SelectedDay = this.route.snapshot.paramMap.get('Day');
    this.SelectedMonth = this.route.snapshot.paramMap.get('month');
    this.SelectedYear = this.route.snapshot.paramMap.get('year');
    this.SelectedFromDate = { year: this.SelectedYear, month: this.SelectedMonth, day: this.SelectedDay };

    //alert(this.SelectedFromDate);
  //  this.SelectedToDate = this.route.snapshot.paramMap.get('SelectedToDate');
    // alert(this.SelectedFromDate);
        //alert(SelectedFromDate3);
    this.LoadPatients();
    //this.CurrentEditCounsellingActivityRequest = new SaveCounsellingActivityRequest;
    //this.CurrentEditCounsellingActivityRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.SelectedToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 2, day: this.TodayDate.getDate() };
    //this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };


  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }
 

}








